import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DataService } from './home-metrics.service';

@Component({
  selector: 'app-home-metrics',
  templateUrl: './home-metrics.component.html',
  styleUrls: ['./home-metrics.component.css']
})
export class HomeMetricsComponent implements OnInit {
  barChartData: any[] = [];

  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.dataService.getData().subscribe(data => {
      this.barChartData = data.map(item => ({
        name: item.date.toISOString().split('T')[0], // Convertir la fecha a un string
        value: item.count
      }));
    });
  }
}
